import React, { Dispatch, useEffect } from "react";
import FilterMenu, { useFilters } from "../fish-map/FilterMenu";
import { useBestSpotsLayer } from "../../fish-map/layers/fish-best-spots";
import { useAISLayer } from "../../fish-map/layers/ais";
import { useHeatmapGridLayer } from "../../fish-map/layers/heat-map-grid";
import { OceanMask } from "../../fish-map/layers/ocean-mask";
import { getTooltip } from "../picked-object-view";
import { PickInfo, ViewStateProps } from "@deck.gl/core/lib/deck";
import "./FilterMenu.css";
import { Page } from "..";
import { getLocationHighlight } from "../../fish-map/layers/highlight-point";
import { Layer } from "@deck.gl/core";
import { getNordStreamLayer } from "../../fish-map/layers/nord-stream";
import { useTranslation } from "../../i18n";

export function FishMap(setLoading: Dispatch<boolean>, setViewState: Dispatch<ViewStateProps | undefined>): Page {

    const [filterState, filterDispatch] = useFilters();

    const bestSpotLayer = useBestSpotsLayer(filterState.daysAhead, filterState.species);
    //const heatmapLayer = useHeatmapLayer(filterState.daysAhead, filterState.species);
    const heatmapLayer2 = useHeatmapGridLayer(filterState.daysAhead, filterState.species, setLoading);

    const [aisLayer, aisVessels] = useAISLayer(filterState.showAISLayer);

    const layers: Layer<any, any>[] = [OceanMask.getOceanMaskLayer(), heatmapLayer2];

    if (filterState.selectedVessel) {
        layers.push(getLocationHighlight(aisVessels[filterState.selectedVessel]));
    }

    layers.push(aisLayer, bestSpotLayer);
    layers.push(...getNordStreamLayer());
    const t = useTranslation();
    const tooltip = (info: PickInfo<any>) => getTooltip(t, info, filterState);

    useEffect(() => {
        if (!filterState.showAISLayer) {
            filterDispatch({ type: 'setSelectedVessel', value: undefined });
            return;
        }
        if (filterState.selectedVessel) {
            const vessel = aisVessels[filterState.selectedVessel];
            setViewState({
                latitude: vessel.geometry.coordinates[1],
                longitude: vessel.geometry.coordinates[0],
                zoom: 8,
                pitch: 40
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterState.showAISLayer, filterState.selectedVessel, setViewState, filterDispatch])

    const menus = <>
        <FilterMenu state={filterState} dispatch={filterDispatch} aisVessels={aisVessels} />
    </>;

    return [
        layers,
        menus,
        tooltip
    ];
}
